var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8083 2.93695C22.9645 3.30695 22.0581 3.55695 21.1051 3.66995C22.0773 3.09395 22.823 2.17995 23.1747 1.09195C22.2652 1.62595 21.2577 2.01395 20.1856 2.22195C19.3266 1.31795 18.1039 0.751953 16.7498 0.751953C14.1507 0.751953 12.0427 2.83795 12.0427 5.41195C12.0427 5.77595 12.0852 6.12995 12.164 6.47195C8.25023 6.27695 4.78311 4.42195 2.46092 1.60395C2.05671 2.29395 1.82429 3.09395 1.82429 3.94595C1.82429 5.56195 2.65596 6.98895 3.9181 7.82395C3.14606 7.79895 2.4205 7.58995 1.78589 7.24095V7.30095C1.78589 9.55795 3.40779 11.441 5.56223 11.869C5.1661 11.975 4.75078 12.031 4.32231 12.031C4.01916 12.031 3.72307 12.003 3.43608 11.949C4.03532 13.799 5.77343 15.147 7.83389 15.183C6.2221 16.433 4.19196 17.178 1.98699 17.178C1.60703 17.178 1.23212 17.156 0.863281 17.113C2.94699 18.436 5.42075 19.206 8.07844 19.206C16.7387 19.206 21.473 12.108 21.473 5.95195C21.473 5.75195 21.4679 5.54995 21.4588 5.34995C22.3784 4.69195 23.1767 3.87295 23.8063 2.93995L23.8083 2.93695Z",
    fill: "#00ACED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.897cf0d0.svg";
export { ForwardRef as ReactComponent };